import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthMe } from '@/hooks/useAuthMe';
import { LoadingState } from '@/components/LoadingState';

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Blocking route guard for `/dashboard/*` and `/admin/*`.
 *
 * Runs the same `/auth/me` check as `HomeRedirect` (CLAUDE.md §8.2) but for
 * deep routes. Preserves the original path + query in a `next` parameter so
 * the user lands back where they meant to go after logging in.
 */
export function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const location = useLocation();
  const me = useAuthMe();

  if (me.isPending) {
    return <LoadingState variant="spinner" label="Anmeldestatus wird geprüft …" />;
  }

  if (me.isError || !me.data) {
    const nextParam = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${nextParam}`} replace />;
  }

  return <>{children}</>;
}
